<template>
  <div>
    <el-card>
      <nav class="out">
        <nav class="input">
          <el-input v-model="form.keyword" size="medium" placeholder="输入标题" />
        </nav>
        <nav class="input">
          <el-button size="small" @click="reset">重置</el-button>
          <el-button type="primary" size="small" @click="getlist">搜索</el-button>
          <el-button type="primary" size="small" @click="addActivityModel">新增模版</el-button>
        </nav>
      </nav>
    </el-card>
    <el-card style="margin-top: 10px">
      <el-table
          :data="tableData"
          style="width: 100%"
          border
          stripe
          :header-cell-style="rowClass"
      >
        <el-table-column prop="id" width="60" label="编号"  />
        <el-table-column prop="title" :show-overflow-tooltip="true" label="问题名称"  />
        <el-table-column  prop="forms" label="内容"  >
          <template slot-scope="{ row }">
            <!--            <b-code-editor v-model="row.search" :auto-format="true" :smart-indent="true" theme="dracula" :indent-unit="4" :line-wrap="false" ref="editor"></b-code-editor>-->
            <el-tooltip  class="item" effect="light"  placement="top">
              <div slot="content">
                <el-form
                    :size="row.eleList.config.size"
                    :label-position="row.eleList.config.labelPosition"
                    :label-width="row.eleList.config.labelWidth + 'px'"
                >
                  <!-- 循环展示拖拽的组件 -->
                  <div
                      v-for="(item, index) in row.eleList.list"
                      :key="index"
                      class="formitem-style"
                  >
                    <el-form-item :label="item.name" :required="item.options.required">
                      <dialogformitems
                          :ele-item="item"
                          :ele-config="row.eleList.config"
                      />
                    </el-form-item>
                  </div>
                </el-form>
              </div>
              <div class="clamp-1" style="overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;">{{ JSON.parse(row.forms) }}</div>
            </el-tooltip>

          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="时间" width="200" />
        <el-table-column sortable prop="sort" label="排序" width="200" >
          <template #header>
            <span>排序</span>
            <div style="font-size:12px">（当前最大值：{{ orderMax }}）</div>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">数值越大，显示越靠前</div>
              <i class="el-icon-warning-outline" style="margin-left: 5px;" />
            </el-tooltip>
          </template>
          <template slot-scope="{ row, $index }">
            <div class="input-box">
              <el-input
                  v-show="row.pai"
                  :ref="'INPUTFOCUS' + $index"
                  v-model="row.sort"
                  size="small"
                  class="id"
                  :autofocus="row.pai"
                  @blur="handleInputBlur(row)"
              />
            </div>
            <span
                v-show="!row.pai"
                class="el-icon-edit"
                @click="
                  showinput(row, 'INPUTFOCUS' + $index)
              "
            >
              {{ row.sort }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="username" label="创建人" width="200" />
        <el-table-column prop="beginTime" label="操作" width="180">
          <template slot-scope="ew">
            <el-button
                type="text"
                icon="el-icon-edit"
                size="mini"
                class="skyblue"
                @click="edit(ew.row.id)"
            >编辑</el-button
            >
            <el-button
                type="text"
                icon="el-icon-delete"
                size="mini"
               style="color: red"
                @click="del(ew.row.id)"
            >删除</el-button
            >

          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
            :current-page="form.page"
            background
            :page-sizes="[3, 5, 10, 15]"
            :page-size="form.pagesize"
            layout="total, prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import $ from "jquery";
import dialogformitems from "@/views/activity/activity_form/newForm/dialogFormItems.vue";
export default {
  components: {dialogformitems},
  data() {
    return {
      form: {
        page: 1,
        pageSize: 10,
        keyword:""
      },
      tableData:[],
      total: 0,
      orderMax:0


    };
  },
  computed: {

  },
  created() {
    this.getlist();
  },
  methods: {
    addActivityModel(){
this.$router.push("/activity_form_add");
    },
    edit(id){
      this.$router.push({
        path: "/activity_form_add",
        query: {
          id: id,
        },
      });
    },
    async delPre(id){
      let { data: res } = await this.$http.post("/admin/ActivityForm/del", {
        id,
      });
      this.getlist()
    },
    /**
     * 删除
     */
     del(id){
      this.$confirm('此操作将永久删除该自定义模版, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
this.delPre(id)
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        return
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    /**
     * 排序
     * @param row
     * @returns {Promise<void>}
     */
    async handleInputBlur(row) {
      this.paiform = row
      try {
        const { data: res } = await this.$http.post(
            '/admin/ActivityForm/updateSort',
            this.paiform
        )
        if (res.errorCode == 200) {
          this.$message.success(res.message)
          //  row.pai=false
          //  this.tableData=[...this.tableData]
          this.getlist()
        }
      } catch (e) {
        // this.$message.error(e)
      }
      console.log(this.tableData)
    },
    showinput(row, refName) {
      console.log(row, refName, this.$refs[refName])
      row.pai = true
      this.tableData = [...this.tableData]
      setTimeout(() => {
        $('.id input').focus()
      }, 0)
    },
    handleSizeChange(e) {
      this.pagesize = e;
      console.log(e);
    },
    handleCurrentChange(e) {
      this.form.page = e;
     this.getlist();
    },
    reset() {
      Object.assign(this.$data, this.$options.data.call(this));
      this.getlist();
    },
    getlist() {
      this.$http
          .get("/admin/ActivityForm/getList", {
            params: {
...this.form
            },
          })
          .then(({ data: res }) => {
            if (res.errorCode == 200) {
              this.tableData=res.data.list.map(item=>{
                return {
                  ...item,
                  pai:false,
                  eleList:{
                    list:JSON.parse(item.forms),
                    config:{
                      labelPosition:'top',
                      labelWidth:100,
                      size:'small'
                    }
                  }
                }
              });
              this.total=res.data.total
              this.orderMax=res.data.orderMax
            }
          });
    },
  },
};
</script>

<style lang="less" scoped>

</style>
